import { Box, Modal } from "@mui/material";
import { IoClose } from "react-icons/io5";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 3,
};

const ConfirmModal = ({
  open,
  setOpen,
  title,
  subTitle,
  handleConfirm,
  confirmLabel = "Konfirmasi",
}) => {
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        sx={{
          ...style,
          width: "30%",
          maxHeight: "85vh",
          padding: 0,
        }}
        className="text-left z-[99999]"
      >
        <div className="p-4">
          <div className="flex justify-between items-center mb-4">
            <p className="text-xl font-semibold text-slate-700">{title}</p>
            <IoClose
              className="hover:text-red-700 cursor-pointer w-5 md:w-6 h-full hover:bg-gray-100 rounded-md transition-transform duration-300 ease-in-out hover:rotate-90"
              onClick={handleClose}
            />
          </div>

          <p className="text-md md:text-base text-slate-500">{subTitle}</p>

          <div className="w-full flex items-center justify-end gap-2 mt-6 font-medium text-md md:text-md">
            <button
              className="py-2 text-md text-slate-500 border border-slate-500 bg-slate-100 rounded-lg hover:bg-slate-200 cursor-pointer px-4 transition-all duration-300"
              onClick={handleClose}
              type="button"
            >
              Batal
            </button>
            <button
              type="submit"
              onClick={handleConfirm}
              className="py-2 text-md text-white cursor-pointer bg-error border border-error hover:bg-red-700 hover:border-red-700 rounded-lg px-4 text-center disabled:bg-gray-300 disabled:border-gray-300 disabled:cursor-default transition-all duration-300"
            >
              <p>{confirmLabel}</p>
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmModal;
